<template>
<div class="chapter">
<div class="inner_page">
<div id="_idParaDest-4">
<div class="ipadfp"><a id="page_x"><img alt="MAP Page Image" class="imagefp" src="image/WeightofNightmap01-2REVBW.jpg"/></a></div><a id="page_x">
</a></div><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?0e1ac995